/**
 * The staff header's second icon column, immediately to the right of
 * SettingsPanel's gear/Stripe stack — sign out on top, a link to the public
 * homepage underneath. Same `.settings__trigger`/`.settings__triggers`
 * styling as that stack (see styles.css), so all four icons in the cluster
 * read as one toolbar despite being two separate components.
 *
 * The public-homepage link opens in a new tab on purpose: staff use it to
 * check that a change (a new listing, updated company info, and so on)
 * actually shows up on the live site, without losing their place in the
 * console they're working in.
 */

import { Home, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useSession } from '../lib/session.js';

export function StaffQuickActions() {
  const { signOut } = useSession();
  const navigate = useNavigate();

  async function onSignOut() {
    await signOut();
    void navigate('/staff/login', { replace: true });
  }

  return (
    <div className="settings__triggers">
      <button
        type="button"
        className="settings__trigger"
        aria-label="Sign out"
        title="Sign out"
        onClick={() => void onSignOut()}
      >
        <LogOut size={16} strokeWidth={2} aria-hidden="true" />
      </button>
      <a
        href="/"
        target="_blank"
        rel="noopener noreferrer"
        className="settings__trigger"
        aria-label="View public homepage (opens in a new tab)"
        title="View public homepage"
      >
        <Home size={16} strokeWidth={2} aria-hidden="true" />
      </a>
    </div>
  );
}
